import { HTMLAttributes, useEffect, useState } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Done } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

export interface BrokerJoveGetQuotesInterface {
  joveSectionTitle: string;
  joveTitle: string;
  joveInfoList: Array<{ title: string }>;
  joveIntroductionImageUrl: string;
}

type BrokerActurisGetQuotesViewProps = HTMLAttributes<HTMLDivElement> & {
  info: BrokerJoveGetQuotesInterface;
};
const BrokerActurisGetQuotesView = (props: BrokerActurisGetQuotesViewProps) => {
  const { className, info } = props;
  const [descList, setDescList] = useState([]);
  const { isMobileLayout } = useJoveBreakpoint();

  /**
   * effects
   */
  useEffect(() => {
    setDescList(info?.joveInfoList || []);
  }, [info]);

  return (
    <Box
      className={clsx('flex flex-row space-x-3 overflow-hidden rounded-3xl bg-white pl-8', className, isMobileLayout ? 'min-h-[400px]' : 'h-[400px]')}
      style={{ boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)' }}
    >
      <Box className="flex flex-1 flex-col justify-center space-y-4 py-5">
        <Box className="flex flex-row self-start rounded-full bg-[#EBEFFE] px-3 py-2">
          <Typography variant="subtitle1" className="text-brand-secondary font-extrabold">
            {info?.joveSectionTitle}
          </Typography>
        </Box>
        <Typography variant="h5" className="text-primary-black font-black">
          {info?.joveTitle}
        </Typography>
        <Box className="flex flex-col space-y-1 overflow-y-auto">
          {descList.map((item, index) => {
            return (
              <Box key={index} className="flex flex-row space-x-2">
                <Done className="text-brand-secondary mt-1" />
                <Typography variant="subtitle1" className="text-primary-black text-lg font-medium">
                  {item.title}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
      {!isMobileLayout && <img width="auto" height="100%" src={info?.joveIntroductionImageUrl} />}
    </Box>
  );
};

export default BrokerActurisGetQuotesView;
